import React from 'react';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './StatusBad.module.css';
import { CommonButton } from '_components';


export class StatusBad extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Bad'} onClick={this.props.onClick} size={this.props.size} className={cls} type='round' >
                <FontAwesomeIcon icon={faXmark} transform="shrink-5" color="red" />
            </CommonButton>
        );
    }
}

